import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { getAbsoluteUrl } from '../../utils/utils';
import { Subscription } from 'rxjs';
import {
  BrandConfig,
  cloneHeaderMap,
} from '../../constants/brand.constants';
import { BrandService } from 'src/app/services/brand.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnDestroy {
  private static readonly HIDDEN_UTILITY_LINKS_BY_BRAND: Partial<
    Record<BrandConfig['key'], string[]>
  > = {
    armorvue: [
      'Service Requests',
      'Make a Payment',
      'Service: (866) 217-9582',
    ],
    newsouth: [
      'Service Requests',
      'Make a Payment',
      'Service: (866) 217-9582',
    ],
  };

  isMobileNavShown = false;
  icons: { [key: string]: SafeHtml };
  headerMap = cloneHeaderMap();
  brandConfig: BrandConfig;
  private brandSub: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    private brandService: BrandService
  ){
    this.brandConfig = this.brandService.getCurrentBrandConfig();
    this.applyBrandHeaderConfig(this.brandConfig);

    this.brandSub = this.brandService.brand$.subscribe((brandConfig) => {
      this.brandConfig = brandConfig;
      this.applyBrandHeaderConfig(brandConfig);
    });

    this.icons = {
      MapPin: this.sanitizer.bypassSecurityTrustHtml(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" role="img" position="left" class="shared_icon__4APFr " aria-hidden="true" style="color:var(--icon-color, currentColor);width:var(--icon-width, var(--icon-size, 16px));height:var(--icon-height, var(--icon-size, 16px))"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6"></path></svg>`),
      HelpCircle: this.sanitizer.bypassSecurityTrustHtml(`<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" role="img" position="left" class="shared_icon__4APFr " aria-hidden="true" style="color:var(--icon-color, currentColor);width:var(--icon-width, var(--icon-size, 16px));height:var(--icon-height, var(--icon-size, 16px))"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"></path></svg>`),
    };
  }

  modifyUrl(link: string) {
    return getAbsoluteUrl(link, this.brandConfig.siteBaseUrl);
  }

  private applyBrandHeaderConfig(brandConfig: BrandConfig): void {
    const nextHeaderMap = cloneHeaderMap();
    nextHeaderMap.ctaButton.title = brandConfig.headerOverrides.ctaTitle;
    nextHeaderMap.ctaButton.href = brandConfig.headerOverrides.ctaHref;

    const showroomItem = nextHeaderMap.utilityNav.find(
      (item: { linkItem: { title: string; href: string } }) =>
        item.linkItem.title === 'Find a Showroom'
    );
    if (showroomItem) {
      showroomItem.linkItem.href = brandConfig.headerOverrides.showroomHref;
    }

    const { salesDisplay, salesHref } = brandConfig.headerOverrides;
    if (salesDisplay && salesHref) {
      const salesItem = nextHeaderMap.utilityNav.find(
        (item: { linkItem: { title: string; href: string } }) =>
          item.linkItem.title.startsWith('Sales:')
      );
      if (salesItem) {
        salesItem.linkItem.title = salesDisplay;
        salesItem.linkItem.href = salesHref;
      }
    }

    const hiddenTitles = HeaderComponent.HIDDEN_UTILITY_LINKS_BY_BRAND[brandConfig.key] ?? [];
    if (hiddenTitles.length > 0) {
      nextHeaderMap.utilityNav = nextHeaderMap.utilityNav.filter(
        (item) => !hiddenTitles.includes(item.linkItem.title)
      );
    }

    this.headerMap = nextHeaderMap;
  }

  toggleMobileNavigation(){
    this.isMobileNavShown = !this.isMobileNavShown;
  }

  ngOnDestroy(): void {
    if (this.brandSub) {
      this.brandSub.unsubscribe();
    }
  }
}
